import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ROLEPLAY_SERVICE, ADMIN_SERVICE } from "../../service/service-url";
import { CreateRolePlayRequest } from '../../model/rolePlay.model';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { RoleplayApiService } from '../roleplay.service';
import { Router } from '@angular/router';
import { CoreApiService } from '../../v2/services/core/core-api.service';

export type StepperContent = {title:string, redirectURL:string, stepId: number, iconName: string};
@Injectable({
  providedIn: 'root'
})
export class RoleplayService {
  private initialRolePlayData: any;
  private RolePlayDataSource = new BehaviorSubject([]);
  private stepperSubject= new BehaviorSubject({current: 1, type: 'N'}); // N - Next, B - Back
  sharedData = this.RolePlayDataSource.asObservable();
  stepperData = this.stepperSubject.asObservable();
  private dataSubject = new BehaviorSubject<any[]>([]);
  data$ = this.dataSubject.asObservable();
  private editModeSubject = new BehaviorSubject<boolean>(false);
  editMode$ = this.editModeSubject.asObservable();
  userId: number = 0;

  stepperContent:StepperContent[] = [
    { title: "Select Customer Profile", redirectURL: "/app-roleplay-step1" ,stepId:1, iconName: "step1-logo.svg"},
    { title: "Define Objectives for Trainee(Field Rep)", redirectURL: "/app-roleplay-step2" ,stepId:2, iconName: "step1-logo.svg"},
    { title: "Customer's Perception", redirectURL: "/app-roleplay-step3" ,stepId:3, iconName: "step3-logo.svg"},
    { title: "Attitude/Communication Style for Customer", redirectURL: "/app-roleplay-step4" ,stepId:4, iconName: "step4-logo.svg"},
    { title: "Roleplay Logistics", redirectURL: "/app-roleplay-step5" ,stepId:5, iconName: "step4-logo.svg"},
    { title: "Roleplay Summary", redirectURL: "/app-roleplay-step6" ,stepId:6, iconName: "step4-logo.svg"}
  ]

  private dataSubject$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  public data$$: Observable<any[]> = this.dataSubject$.asObservable();
  
  constructor(
    private http: HttpClient,
    private roleplayApiService: RoleplayApiService,
    private coreApiService: CoreApiService,
    private router: Router) { 
    this.userId = Number(sessionStorage.getItem('userId'));
  }

  hasChanges(): boolean {
    const initialRolePlayData: {
        scenario_name: string;
        dr_profile_id: number;
        roleplay_metadata: any[];
        step3: boolean;
        step4: boolean;
        step5: boolean;
        avtar_enabled: boolean;
    }= JSON.parse(JSON.stringify(this.rolePlayScenarioData));


    const currentRolePlayData: {
        scenario_name: string;
        dr_profile_id: number;
        roleplay_metadata: any[];
        step3: boolean;
        step4: boolean;
        step5: boolean;
        avtar_enabled: boolean;
    } = {
        scenario_name: this.rolePlayScenarioData.scenario_name,
        dr_profile_id: this.rolePlayScenarioData.dr_profile_id,
        roleplay_metadata: this.rolePlayScenarioData.roleplay_metadata,
        step3: this.rolePlayScenarioData.step3,
        step4: this.rolePlayScenarioData.step4,
        step5: this.rolePlayScenarioData.step5,
        avtar_enabled: this.rolePlayScenarioData.avtar_enabled
    };
    return JSON.stringify(initialRolePlayData) !== JSON.stringify(currentRolePlayData);
}


  getDoctorListData(business_unit_code): Observable<any> {
    return this.http.get(ROLEPLAY_SERVICE.doctorProfileList + business_unit_code);
  }

  getAvatarListData(): Observable<any> {
    return this.http.get(ROLEPLAY_SERVICE.avatarImageList);
  }
  // getMetaDataData() {
  //   return this.http.get(GET_METADATA_LIST.getResponse);
  // }
  getMetaDataData(): Observable<any[]> {
    return this.http.get<any[]>(ROLEPLAY_SERVICE.getMetadataList).pipe(
      tap(data => this.dataSubject$.next(data))
    );
  }

  public rolePlayScenarioData = {
    scenario_name: "",
    additional_summary:"",
    dr_profile_id: 0,
    roleplay_metadata: [
    ],
    step3: false,
    step4: false,
    step5: false,
    created_by: this.userId,
    updated_by: this.userId,
    roleplay_scenario_summary: '',
    avtar_enabled: false,
    business_unit_code: sessionStorage.getItem('businessUnitCode')

  };
  

  public createRolePlayScenario(request: CreateRolePlayRequest):Observable<any> {
    if (request) {
       return this.http.post(ROLEPLAY_SERVICE.createScenario, request);
    }
    else {
        return null;
    }
}
public getRoleplaySummary(request:CreateRolePlayRequest):Observable<any>{
  if(request){
    return this.http.post(ROLEPLAY_SERVICE.generateScenarioSummary,request);
  }
  else{
    return null;
  }
}
public updateRolePlayScenarioWithId(scenario_id: number, request: CreateRolePlayRequest): Observable<any> {
  if (request) {
    
    return this.http.post(`${ROLEPLAY_SERVICE.generateScenarioSummary}?scenario_id=${scenario_id}`, request);
  } else {
    return null;
  }
}



clearSelectedData(): void {
  // this.rolePlayScenarioData.dr_profile_id =  0;
  this.rolePlayScenarioData.roleplay_metadata = [];
  this.rolePlayScenarioData.step3 = false;
  this.rolePlayScenarioData.step4 = false;
  this.rolePlayScenarioData.step5 = false;
}

public updateRolePlayScenario(id: string, request: CreateRolePlayRequest):Observable<any> {
  if (request) {
     return this.http.put(`${ROLEPLAY_SERVICE.updateScenario}/${id}`, request);
  }
  else {
      return null;
  }
}

  setEditMode(value: boolean): void {
    this.editModeSubject.next(value);
  }

  getEditMode(): boolean {
    return this.editModeSubject.value;
  }

  fetchData(id: string): void {
    this.http.get<any[]>(`${ROLEPLAY_SERVICE.getScenarioDetail}/${id}`).subscribe({
      next: ((data)=>{
        this.dataSubject.next(data);
        this.initialRolePlayData = JSON.parse(JSON.stringify(data[0])); 
      }),
      error: error => console.error('Error fetching data', error)
    });
  }
  
  changeData(rolePlayData: any[] = []) {
    this.RolePlayDataSource.next(rolePlayData);
  }
  changeStepper(data: any = {}) {
    this.stepperSubject.next(data);
  } 


   private summaryCache: { [key: string]: any } = {}; // In-memory cache

  // Save summary to cache + localStorage
  setSummaryCache(scenarioId, summaryData: any): void {
    this.summaryCache[scenarioId] = summaryData;
    localStorage.setItem(`summary_${scenarioId}`, JSON.stringify(summaryData));
  }

  // Retrieve summary from cache/localStorage
  getSummaryCache(scenarioId): any | null {
    if (this.summaryCache[scenarioId]) {
      return this.summaryCache[scenarioId];
    }

    const cached = localStorage.getItem(`summary_${scenarioId}`);
    return cached ? JSON.parse(cached) : null;
  }

  // Optional: clear when scenario changes or user logs out
  clearSummaryCache(scenarioId?: string): void {
    if (scenarioId) {
      delete this.summaryCache[scenarioId];
      localStorage.removeItem(`summary_${scenarioId}`);
    } else {
      this.summaryCache = {};
      Object.keys(localStorage)
        .filter(key => key.startsWith('summary_'))
        .forEach(key => localStorage.removeItem(key));
    }
  }

  getDoctorProfileImageUrl(fileNameWithExtension:string):string{
    let url = '';

    const base_url = this.coreApiService.API_M_URL;
    const profile_url = ADMIN_SERVICE.profileImage;
    const business_unit_code = sessionStorage.getItem('businessUnitCode');
    const wwid = sessionStorage.getItem('userId');
    const blobContainer = 'aiadvisor-doctor-profile-image';
    const authorization = localStorage.getItem('bearer_token');

    if (business_unit_code && wwid && authorization) {
      url = `${base_url}${profile_url}?business_unit_code=${business_unit_code}&wwid=${wwid}&blobContainer=${blobContainer}&fileNameWithExtension=${fileNameWithExtension}&Authorization=${authorization}`
    }

    return url;
  }

  changeStep(stepper_data: StepperContent){
    this.router.navigate([stepper_data.redirectURL, { mode: 'roleplay' }], { skipLocationChange: true });
    this.changeStepper({ current: stepper_data.stepId, type: 'N' });
  }
}
